module.exports = __webpack_public_path__ + "exljbris_-_museosans-700italic-webfont.e870efc1c07633b5c9b7.woff2";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/exljbris_-_museosans-700italic-webfont.woff2
// module id = ../../../../../src/assets/fonts/exljbris_-_museosans-700italic-webfont.woff2
// module chunks = styles